/** The letter a party goes by, in the order the parties are named: A, B, … */
export const partyLetter = (index: number): string =>
  String.fromCharCode(65 + (index % 26));
